import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import OtpModalSignUp from "./OtpModalSignUp";
import { signUpValidate } from "../../Services/authService";
import { Helmet } from "react-helmet";
import "./AnimatedBackground.css";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import Loader from "../../Loader";

import { showSuccessToast, showErrorToast } from "../../utils/toastUtils";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ReCAPTCHA from "react-google-recaptcha";

const SignUpForm = () => {
  const [webConfirm, setWebConfirm] = useState("");
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [captchaToken, setCaptchaToken] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [referenceId, setReferenceId] = useState(null);

  const [formData, setFormData] = useState({
    referredBy: "",
    email: "",
    password: "",
    confirmPassword: "",
    mobile: "",
    website: "",
  });

  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const passwordsMatch =
    formData.password && formData.confirmPassword
      ? formData.password === formData.confirmPassword
      : null;

  // const handleSignUp = async () => {
  //   // Basic client-side validation
  //   if (!formData.email.trim()) return showErrorToast("Enter email");
  // if (!webConfirm) {
  //   return showErrorToast("Please select Yes or No for website login");
  // }
  // if (webConfirm === "yes" && !formData.website.trim()) {
  //   return showErrorToast("Enter website Domain");
  // }

  //   if (formData.password.length < 8)
  //     return showErrorToast("Password length must be at least 8");
  //   if (formData.password !== formData.confirmPassword)
  //     return showErrorToast("Passwords do not match");
  //   if (!/^\d{10}$/.test(formData.mobile))
  //     return showErrorToast("Enter a valid 10-digit mobile number");

  //   // Map formData to payload
  //   const payload = {
  //     email_address: formData.email,
  //     mobile_number: formData.mobile,
  //     password: formData.password,
  //     confirm_password: formData.confirmPassword,
  //     website_login: webConfirm === "yes",  // ✅ automatically true or false
  //     company_domain: webConfirm === "yes" ? formData.website : "",
  //   };

  //   try {
  //     const response = await signUpValidate(payload);

  //     if (response?.status?.code === 200) {
  //       const lastFour = formData.mobile.slice(-4);
  //       setReferenceId(response?.data?.identifier);
  //         setFormData((prev) => ({ ...prev, lastFourDigits: lastFour }));
  //       showSuccessToast(response?.message || "Validation successful");
  //       setShowOtpModal(true);
  //     } else {
  //       showErrorToast(response?.status?.message || "Validation failed");
  //     }
  //   } catch (error) {
  //     if (error.response?.status === 422 && error.response?.data?.errors) {
  //       const backendErrors = error.response.data.errors;
  //       Object.values(backendErrors).forEach((errArray) => {
  //         errArray.forEach((errMsg) => showErrorToast(errMsg));
  //       });
  //     } else {
  //       showErrorToast(error.response?.data?.message || "Sign Up validation failed");
  //     }
  //   }
  //    finally {
  //     setIsLoading(false);
  //   }
  // };

  const handleSignUp = async () => {
    if(!captchaToken) return showErrorToast("Check Captcha");
    if (!formData.email.trim()) return showErrorToast("Enter email");
    if (!webConfirm)
      return showErrorToast("Please select Yes or No for website login");
    if (webConfirm === "yes" && !formData.website.trim())
      return showErrorToast("Enter website Domain");
    if (formData.password.length < 8)
      return showErrorToast("Password length must be at least 8");
    if (formData.password !== formData.confirmPassword)
      return showErrorToast("Passwords do not match");
    if (!/^\d{10}$/.test(formData.mobile))
      return showErrorToast("Enter a valid 10-digit mobile number");

    const payload = {
      email_address: formData.email,
      mobile_number: formData.mobile,
      password: formData.password,
      confirm_password: formData.confirmPassword,
      website_login: webConfirm === "yes",
      company_domain: webConfirm === "yes" ? formData.website : "",
    };

    try {
      setIsLoading(true);

      const apiRes = await signUpValidate(payload);

      // normalize to make sure we can read the right level
      const res = apiRes?.data?.status ? apiRes.data : apiRes;
      const status = res?.status || {};

      // ✅ Success branch
      if (status.code === 200) {
        const lastFour = formData.mobile.slice(-4);
        setReferenceId(res?.data?.identifier);
        setFormData((prev) => ({ ...prev, lastFourDigits: lastFour }));

        showSuccessToast(
          status.message || res?.message || "Validation successful",
        );
        setShowOtpModal(true);
        return;
      }

      // ❌ Validation Error (422)
      if (status.code === 422) {
        const backendErrors = res?.errors || res?.data?.errors;
        if (backendErrors) {
          Object.values(backendErrors)
            .flat()
            .forEach((msg) => showErrorToast(msg));
        } else {
          showErrorToast(status.message || "Validation failed");
        }
        return;
      }

      // fallback
      showErrorToast(status.message || res?.message || "Validation failed");
    } catch (error) {
      console.error("❌ Error:", error);

      const errRes = error?.response?.data || {};
      const code = error?.response?.status || errRes?.status?.code;

      if (code === 422 && errRes?.errors) {
        Object.values(errRes.errors)
          .flat()
          .forEach((msg) => showErrorToast(msg));
        return;
      }

      showErrorToast(
        errRes?.status?.message ||
          errRes?.message ||
          error?.message ||
          "Sign Up validation failed",
      );
    } finally {
      setIsLoading(false);
    }
  };

  // function extractMessagesFromErrors(errors) {
  //   const msgs = [];

  //   if (!errors) return msgs;

  //   // if it's an array of messages already
  //   if (Array.isArray(errors)) {
  //     errors.forEach((e) => {
  //       if (typeof e === "string") msgs.push(e);
  //       else if (Array.isArray(e)) e.forEach(x => msgs.push(String(x)));
  //       else msgs.push(JSON.stringify(e));
  //     });
  //     return msgs;
  //   }

  //   // if it's an object like { field: [..], field2: "..." }
  //   if (typeof errors === "object") {
  //     Object.values(errors).forEach((val) => {
  //       if (Array.isArray(val)) {
  //         val.forEach((v) => { if (v) msgs.push(String(v)); });
  //       } else if (typeof val === "string") {
  //         msgs.push(val);
  //       } else if (val) {
  //         msgs.push(String(val));
  //       }
  //     });
  //     return msgs;
  //   }

  //   // fallback
  //   msgs.push(String(errors));
  //   return msgs;
  // }

  const handleCaptchaChange = () => {
    setCaptchaToken(!captchaToken);
  };

  const cleanUrl = (url) => url.replace(/^https?:\/\//, "").trim();

  const handleProtocolChange = (e) => {
    const protocol = e.target.value;
    const domain = cleanUrl(formData.website);
    setFormData((prev) => ({
      ...prev,
      website: domain ? `${protocol}://${domain}` : "",
    }));
  };

  const handleDomainChange = (e) => {
    const domain = cleanUrl(e.target.value);
    // Extract existing protocol from current website if any
    const protocolMatch = formData.website.match(/^(https?):\/\//);
    const protocol = protocolMatch ? protocolMatch[1] : "https";
    setFormData((prev) => ({
      ...prev,
      website: domain ? `${protocol}://${domain}` : "",
    }));
  };

  // Helper to extract current protocol for select dropdown
  const getProtocol = () => {
    const match = formData.website.match(/^(https?):\/\//);
    return match ? match[1] : "https";
  };

  // Helper to extract domain part for input
  const getDomain = () => cleanUrl(formData.website);
  return (
    <div className="relative flex flex-col md:flex-row justify-center items-center min-h-screen bg-blue-700 overflow-hidden">
      <Helmet>
        <title>
          Create IDSPay API Account | Get Free API Access to UPI Gateway,
          Recharge & Fintech APIs
        </title>
        <meta
          name="description"
          content="Create your IDSPay API account to access payment, recharge & fintech APIs instantly. Simple signup,
           secure integration & free developer access. IDSPay API signup for UPI Gateway, Recharge & Fintech APIs.
            Free registration for developers to access secure digital service APIs. Register for IDSPay API access & start integrating payment, recharge, Fintech API's & 150+ digital services in minutes. Fast, secure & developer-friendly platform."
        />
        <meta
          name="keywords"
          content="IDSPay API Create Account, IDSPay API Registration, Payment Gateway API Signup,
           Recharge API Registration, Fintech API Integration, Free Developer API Access,
            Create Developer Account IDSPay, Digital Payment API Platform, API for Recharge & Bill Payment,
             Money Transfer API Integration, Banking & Finance API Access, White Label API Solutions,
              Secure Payment Gateway API India, Developer API Portal, API Documentation for Developers,
               Start API Integration with IDSPay"
        />

        <meta name="author" content="IDSPay" />
      </Helmet>

      {isLoading && <Loader />}

      {/* 🔹 Morph Background Layer */}
      <div className="absolute inset-0 z-0">
        <div className="mb-page-wrapper">
          <div className="mb-grid-animation">
            {[...Array(5)].map((_, i) => (
              <div key={`v-${i}`} className="mb-grid-line-v"></div>
            ))}
            {[...Array(5)].map((_, i) => (
              <div key={`h-${i}`} className="mb-grid-line-h"></div>
            ))}
          </div>
          <div className="mb-main-container"></div>
        </div>
      </div>

      {/* 🔹 Left Section */}
      <div className="hidden md:flex relative z-10 w-full h-screen rounded-xl md:w-1/2 flex-col justify-between text-left p-4 md:p-12 text-white overflow-hidden">
        {/* ✅ Text Below Image */}
        <div className="flex flex-col justify-center text-white space-y-2">
          <h2 className="w-full text-2xl md:text-4xl font-bold mb-2 underline">
            Boost Your Business with IDSPay
          </h2>

          <p className="w-full text-base md:text-lg opacity-90 leading-relaxed">
            Empower your Business with seamless Open API and secure access. Join
            us today and experience the future of digital innovation.
          </p>
        </div>
        {/* ✅ Image on Top */}
        <div className="w-full bottom-0">
          <img
            src="assets/idspay-signup2.png"
            alt="Background"
            className="w-full h-auto object-scale-down rounded-xl"
          />
        </div>
      </div>

      {/* 🔹 Right Section (Sign Up Form) */}
      <div className="relative z-10 w-full md:w-1/2 flex justify-center p-3 md:p-10">
        <div className="bg-white/20 backdrop-blur-md shadow-xl rounded-2xl md:p-5 p-3 w-full max-w-md border border-white/30">
          <h2 className="text-2xl font-semibold text-center mb-4 text-white underline">
            Create API Account
          </h2>
          <p className="text-center text-sm text-white mb-5">
            Already have an account?{" "}
            <Link
              to="/"
              className="text-yellow-600 font-medium hover:underline"
            >
              Login
            </Link>
          </p>

          <div className="space-y-3">
            {/* UserId */}
            <div>
              <label className="block text-md font-medium text-white">
                Email<span className="text-red-500 ms-1">*</span>
              </label>
              <input
                type="email"
                name="email"
                placeholder="Enter your email id"
                value={formData.email}
                onChange={handleChange}
                required
                className="w-full border border-gray-300 rounded-md px-3 py-2 mt-1 focus:outline-none focus:ring-2 focus:ring-red-500"
              />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-1">
              {/*  Password */}
              <div>
                <label className="block text-md font-medium text-white">
                  Set a Password<span className="text-red-500 ms-1">*</span>
                </label>
                <div className="relative">
                  <input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    placeholder="New Password"
                    value={formData.password}
                    onChange={handleChange}
                    required
                    className={`w-full border rounded-md px-3 py-2 mt-1 focus:outline-none 
              ${
                passwordsMatch === null
                  ? "border-gray-300"
                  : passwordsMatch
                    ? "border-green-500"
                    : "border-red-500"
              }`}
                  />
                  <span
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute right-3 top-4 text-blue-500 cursor-pointer"
                  >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </span>
                </div>
              </div>

              {/*  Confirm Password */}
              <div>
                <label className="block text-md font-medium text-white">
                  Confirm Password<span className="text-red-500 ms-1">*</span>
                </label>
                <div className="relative">
                  <input
                    type={showConfirm ? "text" : "password"}
                    name="confirmPassword"
                    placeholder="Confirm Password"
                    value={formData.confirmPassword}
                    onChange={handleChange}
                    required
                    className={`w-full border rounded-md px-3 py-2 mt-1 focus:outline-none 
              ${
                passwordsMatch === null
                  ? "border-gray-300"
                  : passwordsMatch
                    ? "border-green-500"
                    : "border-red-500"
              }`}
                  />
                  <span
                    onClick={() => setShowConfirm(!showConfirm)}
                    className="absolute right-3 top-4 text-blue-500 cursor-pointer"
                  >
                    {showConfirm ? <FaEyeSlash /> : <FaEye />}
                  </span>
                </div>
                {passwordsMatch === false && (
                  <p className="text-red-500 text-xs">Passwords do not match</p>
                )}
                {passwordsMatch && (
                  <p className="text-green-500 text-xs">Passwords match</p>
                )}
              </div>
            </div>

            {/* Mobile */}
            <div>
              <label className="block text-md font-medium text-white">
                Mobile<span className="text-red-500 ms-1">*</span>
              </label>
              <div className="flex items-center mt-1 border border-gray-300 bg-white rounded-md overflow-hidden">
                <span className="px-3 bg-white text-black">+91</span>
                <input
                  type="tel"
                  name="mobile"
                  placeholder="Enter your 10 digit mobile number"
                  value={formData.mobile}
                  maxLength={10}
                  onChange={handleChange}
                  required
                  className="w-full px-3 py-2 focus:outline-none"
                />
              </div>
            </div>

            <div>
              <label className="block text-md font-medium text-white">
                Referred by
              </label>
              <div className="flex items-center mt-1 border border-gray-300 bg-white rounded-md overflow-hidden">
                <input
                  type="text"
                  name="referredBy"
                  placeholder="Enter your Employee Id"
                  value={formData.referredBy}
                  onChange={handleChange}
                  required
                  className="w-full px-3 py-2 focus:outline-none"
                />
              </div>
            </div>

            <div className="space-y-4">
              {/* Radio Buttons */}
              <div>
                <p className="text-md font-medium text-white">
                  Do you have company website?
                </p>
                <div className="flex gap-6 mt-2">
                  <label className="flex items-center">
                    <input
                      type="radio"
                      name="webConfirm"
                      value="yes"
                      checked={webConfirm === "yes"}
                      onChange={(e) => setWebConfirm(e.target.value)}
                      className="text-green-600 focus:ring-green-500"
                    />
                    <span className="ml-2 text-white">Yes</span>
                  </label>
                  <label className="flex items-center">
                    <input
                      type="radio"
                      name="webConfirm"
                      value="no"
                      checked={webConfirm === "no"}
                      onChange={(e) => setWebConfirm(e.target.value)}
                      className="text-green-600 focus:ring-green-500"
                    />
                    <span className="ml-2 text-white">No</span>
                  </label>
                </div>
              </div>

              {/* Conditional Website Input */}
              {webConfirm === "yes" && (
                <div className="">
                  <div className="flex">
                    <select
                      value={getProtocol()}
                      onChange={handleProtocolChange}
                      className="border border-gray-300 rounded-l-md px-3 py-2 bg-white text-gray-700 focus:outline-none focus:ring-2 focus:ring-green-500"
                    >
                      <option value="http">http://</option>
                      <option value="https">https://</option>
                    </select>

                    <input
                      type="text"
                      placeholder="yourwebsite.com"
                      value={getDomain()}
                      onChange={handleDomainChange}
                      className="w-full border border-gray-300 rounded-r-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500"
                    />
                  </div>

                  {formData.website && (
                    <p className="text-green-400 text-xs mt-1">
                      Full URL: {formData.website}
                    </p>
                  )}
                </div>
              )}
            </div>

            <div className="w-full md:w-full transform scale-[0.77] md:scale-[0.77] origin-left">
              <ReCAPTCHA
                sitekey="6LdVjzIqAAAAAGc1B3BkXGFyUZmHTUYyI1aE_FtA"
                onChange={handleCaptchaChange}
              />
            </div>

            {/* Submit Button */}
            <button
              type="button"
              onClick={handleSignUp}
              className="w-full bg-green-600 text-white font-medium py-2 rounded-md hover:bg-green-700 transition"
            >
              SEND OTP & VERIFY
            </button>

            <p className="text-center text-xs text-white mt-3">
              By signing up, you agree to our{" "}
              <a href="#" className="text-green-600 hover:underline">
                Terms & Conditions
              </a>{" "}
              and{" "}
              <a href="#" className="text-white hover:underline">
                Privacy Policy
              </a>
            </p>
          </div>
        </div>
      </div>
      <OtpModalSignUp
        isModalOpen={showOtpModal}
        toggleModal={() => setShowOtpModal(false)}
        referenceId={referenceId}
        formData={formData}
        webConfirm={webConfirm}
        lastFourDigits={formData.lastFourDigits}
        onSuccess={() => {
          setShowOtpModal(false);
          navigate("/Dashboard"); // redirect after storing token
        }}
      />

      {showModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          <div className="absolute inset-0 bg-black/30 backdrop-blur-sm"></div>

          {/* Modal content */}
          <div className="relative bg-white/90 rounded-xl p-8 w-11/12 max-w-md shadow-lg text-center z-10">
            {/* Close button */}
            <button
              className="absolute top-3 right-3 text-gray-600 hover:text-gray-900"
              onClick={() => setShowModal(false)}
            >
              ✕
            </button>

            {/* Icon */}
            <div className="mx-auto w-16 h-16 bg-green-500 rounded-full flex items-center justify-center mb-4">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-8 w-8 text-white"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={3}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>

            {/* Text */}
            <h2 className="text-2xl font-bold mb-2">Successful Registration</h2>
            <p className="text-gray-700 mb-6">
              Thank you! You have successfully registered with IDSPay. You can
              now proceed to the Login and Complete Profile.
            </p>

            {/* Continue Button */}
            <button
              onClick={() => showSuccessToast("Login Clicked")}
              className="bg-blue-600 text-white px-6 py-2 rounded-full hover:bg-blue-700 transition"
            >
              <Link to="/"> Login</Link>
            </button>
          </div>
        </div>
      )}

      <ToastContainer />
    </div>
  );
};

export default SignUpForm;
